import { makeStyles } from 'tss-react/mui';
import { BACKGROUND_GREY_LIGHT, CAPTION_GREY } from 'utilities/colors';
import { PATHOLOGY_MAP_EVEN_SLIDE_DATA_BG_COLOR } from 'components/PathologyMap/constants/styles';

export const useAnnotationItemStyles = makeStyles()(() => ({
  annotationCaption: {
    fontSize: '1.125rem',
    marginLeft: '0.75rem',
    marginBottom: '0.5rem',
  },
  image: {
    width: '100%',
    maxHeight: 250,
    paddingRight: '1rem',
  },
  commentContainer: {
    paddingBlock: '0.5rem',
  },
  submittedUser: {
    fontWeight: 500,
  },
  commentText: {
    fontFamily: 'monospace',
    fontSize: '1rem',
    color: CAPTION_GREY,
  },
  slideDataContainer: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
    padding: '0.5rem',
    background: 'transparent',
    '&:nth-of-type(even)': {
      backgroundColor: PATHOLOGY_MAP_EVEN_SLIDE_DATA_BG_COLOR,
    },
    '&:nth-of-type(odd)': {
      '&:hover': {
        backgroundColor: BACKGROUND_GREY_LIGHT,
      },
    },
    transition: 'filter 0.3s',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      cursor: 'pointer',
      filter: 'brightness(0.95)',
    },
  },
  placeholderText: {
    height: 150,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
